<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          Ship Via
          <CButton size="sm" style="float:right;" color="success" @click="addModal = true">Add Ship Via</CButton>
        </CCardHeader>
        <CCardBody>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <CDataTable
            :items="items"
            :fields="fields"
            column-filter
            table-filter
          >
          <!-- <template #show="{item}">
            <td>
              <CButton size="sm" color="primary" @click="show( item.program_id )">Show</CButton>
            </td>
          </template> -->
          <template #active_for_all="{item}">
            <td>
              {{item.active_for_all ? 'Yes' : 'No'}}
            </td>
          </template>
          <template #default="{item}">
            <td>
              {{item.default ? 'Yes' : 'No'}}
            </td>
          </template>
          <template #edit="{item}">
            <td>
              <CButton size="sm" color="primary" @click="editForm = item, editModal = true">Edit</CButton>
            </td>
          </template>
          <!-- <template #delete="{item}">
            <td>
              <CButton size="sm" v-if="you!=item.id" color="danger" @click="deleteUser( item.id )">Delete</CButton>
            </td>
          </template> -->
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>

      <CModal
        title="Add Ship Via"
        :show.sync="addModal"
      >
        <CForm>
          <CInput
            :lazy="false"
            label="Ship Via Code"
            :value.sync="form.ship_via_code"
            placeholder="Ship Via Code"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Ship Via Text"
            :value.sync="form.ship_via_text"
            placeholder="Ship Via Text"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Active For All?</label>
            <div>
              <CButton size="sm" @click="form.active_for_all = 1" :color="form.active_for_all === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.active_for_all = 0" style="margin-left:5px;" :color="form.active_for_all === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Default?</label>
            <div>
              <CButton size="sm" @click="form.default = 1" :color="form.default === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.default = 0" style="margin-left:5px;" :color="form.default === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>

          <CInput
            :lazy="false"
            label="Ship Via Internal Id"
            :value.sync="form.internal_id"
            placeholder="Ship Via Internal Id"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Term Internal Id"
            :value.sync="form.term_internal_id"
            placeholder="Term Internal Id"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Code Groups (separate with comma)"
            :value.sync="form.code_groups"
            placeholder="Code Groups"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div class="float-left col-sm-12 p-0">
            <label>User Groups</label>
            <v-select v-if="roles" v-model="form.user_groups" multiple :options="roles"></v-select>
          </div>
        </CForm>
        <template #footer>
          <CButton @click="addModal = false, reset()" color="danger">Cancel</CButton>
          <CButton @click="add()" color="success">Add</CButton>
        </template>
      </CModal>

      <CModal
        title="Edit Ship Via"
        :show.sync="editModal"
      >
        <CForm v-if="editForm">
          <CInput
            :lazy="false"
            label="Ship Via Code"
            :value.sync="editForm.ship_via_code"
            placeholder="Ship Via Code"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Ship Via Text"
            :value.sync="editForm.ship_via_text"
            placeholder="Ship Via Text"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Active For All?</label>
            <div>
              <CButton size="sm" @click="editForm.active_for_all = 1" :color="editForm.active_for_all === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="editForm.active_for_all = 0" style="margin-left:5px;" :color="editForm.active_for_all === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Default?</label>
            <div>
              <CButton size="sm" @click="editForm.default = 1" :color="editForm.default === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="editForm.default = 0" style="margin-left:5px;" :color="editForm.default === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <CInput
            :lazy="false"
            label="Ship Via Internal Id"
            :value.sync="editForm.internal_id"
            placeholder="Ship Via Internal Id"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Term Internal Id (if blank, it will be sent as 2 (standard))"
            :value.sync="editForm.term_internal_id"
            placeholder="Term Internal Id"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Code Groups (separate with comma)"
            :value.sync="editForm.code_groups"
            placeholder="Code Groups"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div class="float-left col-sm-12 p-0">
            <label>User Groups</label>
            <v-select v-if="roles" v-model="editForm.user_groups" multiple :options="roles"></v-select>
          </div>
          <div class="float-left col-sm-12 p-0">
            <label>Exclude Groups</label>
            <v-select v-if="roles" v-model="editForm.exclude_groups" multiple :options="roles"></v-select>
          </div>
        </CForm>
        <template #footer>
          <CButton @click="editModal = false, resetEdit()" color="danger">Cancel</CButton>
          <CButton @click="save()" color="success">Save</CButton>
        </template>
      </CModal>
    </CCol>
  </CRow>
</template>

<script>
import Multiselect from 'vue-multiselect'
var methods = {}

methods.getData = function () {
  let self = this
  axios.get( this.$apiAdress + '/api/ship_vias?token=' + localStorage.getItem("api_token"))
  .then(function (response) {
    console.log(response)
    self.items = response.data
  }).catch(function (error) {
    console.log(error)
  });
}

methods.reset = function () {
  this.form = {name: ''}
}

methods.resetEdit = function () {
  this.editModal = null
}

methods.save = function () {
  let self = this
  axios.post(this.$apiAdress + '/api/ship_vias/store?token=' + localStorage.getItem('api_token'), self.editForm)
  .then(function (response) {
    self.editModal = false
    self.editForm = ''
  }).catch(function (error) {
    console.log(error)
  })
}

methods.add = function () {
  let self = this;
  axios.post(   this.$apiAdress + '/api/ship_vias/store?token=' + localStorage.getItem("api_token"),
    self.form
  )
  .then(function (response) {
      console.log(response)
      self.addModal = false
      self.form = self.getForm()
      // this.$router.push({ path: '/techniques/' + val + '/edit' })
      // self.items.push(response.data)
      // self.form = {style_name: ''}
      // self.addModal = false
  }).catch(function (error) {
      // if(error.response.data.message == 'The given data was invalid.'){
      //   self.message = '';
      //   for (let key in error.response.data.errors) {
      //     if (error.response.data.errors.hasOwnProperty(key)) {
      //       self.message += error.response.data.errors[key][0] + '  ';
      //     }
      //   }
      //   self.showAlert();
      // }
  });
}

methods.getRoles = function () {
  axios.get(this.$apiAdress + '/api/roles?token=' + localStorage.getItem('api_token')).then(response => {
    console.log(response)
    // this.roles = response.data
    var that = this
    this.roles = []
    response.data.forEach(function (val) {
      that.roles.push(val.name)
    })
  })
}

methods.getForm = function () {
  return {
    id: '',
    ship_via_code: '',
    ship_via_text: '',
    active_for_all: '',
    internal_id: '',
    term_internal_id: '',
    code_groups: '',
    default: 0,
    user_groups: '',
    exclude_groups: ''
  }
}

export default {
  name: 'ShipViaTable',
  data() {
    return {
      items: [],
      roles: '',
      fields: ['ship_via_code', 'ship_via_text', 'active_for_all', 'default', 'code_groups', 'user_groups', 'exclude_groups', 'edit'],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      programs: null,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      addModal: false,
      form: this.getForm(),
      editForm: null,
      editModal: false,
    }
  },
  components: {
    Multiselect
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  methods: methods,
  mounted: function(){
    this.getData()
    this.getRoles()
  }
}
</script>
